/* eslint-disable prettier/prettier */
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, type SubmitHandler } from "react-hook-form";
import { z } from "zod";
import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { TextControl } from "../ui/formInputs";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { getApi } from "../../hooks/useApi";

const FormSchema = z
	.object({
		password: z
			.string({
				required_error: "Por favor, introduce una nueva contraseña.",
			})
			.min(
                8,
                "La contraseña debe tener al menos 8 caracteres, una letra mayúscula, una letra minúscula y un número."
            )
            .regex(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
                "La contraseña debe tener al menos 8 caracteres, una letra mayúscula, una letra minúscula y un número."
            ),
		repeatPassword: z
			.string({
				required_error: "Por favor, repite la contraseña.",
			})
			.min(
                8,
                "La contraseña debe tener al menos 8 caracteres, una letra mayúscula, una letra minúscula y un número."
            )
            .regex(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
                "La contraseña debe tener al menos 8 caracteres, una letra mayúscula, una letra minúscula y un número."
            ),
	})
	.refine((data) => data.password === data.repeatPassword, {
		message: "Las contraseñas no coinciden.",
		path: ["repeatPassword"],
	});

type FormType = z.infer<typeof FormSchema>;

interface NewPasswordFormProps {
	token: string;
}

export function NewPasswordForm(props: NewPasswordFormProps) {
	const navigate = useNavigate();
	const [message, setMessage] = useState<{
		msg: string;
		type: "info" | "error";
	} | null>(null);
    const api = getApi();
	const form = useForm<FormType>({
		resolver: zodResolver(FormSchema),
		defaultValues: {
			password: "",
			repeatPassword: "",
		},
	});

	const onSubmit: SubmitHandler<FormType> = async (data) => {
		setMessage(null);

		try {
			const response = await api.request("post", "/v1/Auth/resetPassword", {
				header: {
					Authorization: "public",
				},
				body: {
					token: props.token,
					new_password: data.password,
				},
			});

			if (response.error) {
			throw response.error;
		}

		setMessage({
			msg: "La contraseña se ha restablecido correctamente.",
			type: "info",
		});

		setTimeout(() => {
			navigate("/login");
		}, 1500);
	} catch (err) {
		console.error(err);

		setMessage({
			msg: "No se ha podido restablecer la contraseña. El enlace puede haber expirado o no ser válido.",
			type: "error",
		});
	}
};

	return (
		<Form {...form}>
			<form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
				{message != null && (
					<div
						className={
							message.type === "error"
								? "text-red-600 text-sm"
								: "text-green-600 text-sm"
						}
					>
						{message.msg}
					</div>
				)}

				<TextControl
					control={form.control}
					name="password"
					label="Nueva contraseña"
					placeholder="Nueva contraseña"
					type="password"
					autoComplete="new-password"
				/>

				<TextControl
					control={form.control}
					name="repeatPassword"
					label="Repetir contraseña"
					placeholder="Repetir contraseña"
					type="password"
					autoComplete="new-password"
				/>

				<div className="flex justify-between items-center">
					<Button type="button" variant="outline" onClick={() => navigate("/login")}>
						Cancelar
					</Button>

					<Button type="submit">Guardar contraseña</Button>
				</div>
			</form>
		</Form>
	);
}